import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@design-system';

const CARE_STARTED_DISABLED_TOOLTIP =
  'Not used while the client is on claim, this is a pre-care assumption.';

/**
 * Wraps a form control so it appears disabled (50% opacity, cursor-not-allowed,
 * pointer-events blocked) and shows an on-claim explanation on hover.
 *
 * Used for fields that don't apply once the client has started LTC. Mirrors the
 * `EdjPilotRestricted` pattern.
 */
export function DisabledByCareTooltip({
  active,
  children,
}: {
  active: boolean;
  children: ReactNode;
}) {
  if (!active) return <>{children}</>;
  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <div className="cursor-not-allowed">
          <div
            className="pointer-events-none opacity-50"
            aria-disabled="true"
            onKeyDown={e => e.preventDefault()}
            onFocusCapture={e => e.stopPropagation()}
            tabIndex={-1}
          >
            {children}
          </div>
        </div>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="max-w-xs text-xs font-normal normal-case"
      >
        {CARE_STARTED_DISABLED_TOOLTIP}
      </TooltipContent>
    </Tooltip>
  );
}
